import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { Card, ScreenReaderContainer } from 'components';
import { Icon, Text } from 'components/chroma';
import { HistoryDetail } from 'scenes/common/flows/policyDetails/types';

const detailDescription: {
  [key in HistoryDetail]: string;
} = {
  [HistoryDetail.InsuranceClaimRefused]: 'Had an insurance claim refused?',
  [HistoryDetail.DeniedPurchase]:
    'Been denied purchase of a new or renewed insurance?',
  [HistoryDetail.ConvictedBurglary]:
    'Been convicted of burglary, theft, arson or fraud?',
  [HistoryDetail.ConvictedCriminalOffence]:
    'Been convicted of any other criminal offence?',
  [HistoryDetail.None]: 'None of the above',
};

const CardWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const HistoryCard: FunctionComponent<{
  historyDetail: HistoryDetail;
  selected: boolean;
  onClick: () => void;
  screenReaderText: string;
}> = ({ historyDetail, selected, onClick, screenReaderText }) => (
  <Card
    id={historyDetail}
    selected={selected}
    center
    onClick={onClick}
    role="button"
  >
    <CardWrapper data-testid={`${historyDetail}${selected ? '-selected' : ''}`}>
      <Icon name="checkCircle" margin={{ right: 5 }} />
      <Text>{detailDescription[historyDetail]}</Text>
      <ScreenReaderContainer>{screenReaderText}</ScreenReaderContainer>
    </CardWrapper>
  </Card>
);
